import type { Bono } from '../types/content'

export const bonos: Bono[] = [
  {
    index: '01',
    emoji: '🧮',
    title: 'Calculadora Proteica Personal',
    value: '$15.000 ARS',
    description:
      'Tu número exacto de proteína diaria en 2 minutos. Sin apps pagas. Sin confusión. Calculado según tu peso, objetivo y nivel de actividad real.',
  },
  {
    index: '02',
    emoji: '🛒',
    title: 'Lista Smart de Súper',
    value: '$16.000 ARS',
    description:
      'La lista de compras semanal optimizada para proteína máxima al menor costo. Organizada por secciones para que la compra dure menos de 30 minutos.',
  },
  {
    index: '03',
    emoji: '📆',
    title: 'Tracker 14 Días Sin Delivery',
    value: '$15.000 ARS',
    description:
      'El desafío que rompe el hábito del delivery para siempre. Registrá cada día y visualizá el ahorro real acumulado en pesos argentinos.',
  },
  {
    index: '04',
    emoji: '🌙',
    title: 'Kit SOS 11 PM',
    value: '$17.000 ARS',
    description:
      '10 soluciones proteicas de rescate para cuando son las 11 PM, tenés hambre y no hay nada listo. Tu red de seguridad para los días de catástrofe.',
  },
  {
    index: '05',
    emoji: '⚖️',
    title: 'Banco de Porciones y Macros',
    value: '$15.000 ARS',
    description:
      'Estimá proteína, carbos y grasas sin báscula ni app en 10 segundos. El sistema visual que te libera de contar calorías para siempre.',
  },
  {
    index: '06',
    emoji: '🧊',
    title: 'Plantillas de Heladera y Alacena',
    value: '$16.000 ARS',
    description:
      'Organizá tu heladera para que la proteína siempre esté visible y lista. Sistema de zonas, etiquetas y rotación para que nunca más se venza comida.',
  },
]

export const bonosTotalValue = '$94.000 ARS'
